import React from "react";
import styles from './Option.module.scss'

function Option({ option, selected = false, children, onSelected = () => { } }) {
    return <div
        onClick={() => onSelected(option)}
        className={`${styles.Option} ${selected ? styles.selected : ''}`}>
        {children}
    </div>
}

export default Option;
